import moment from "moment";
import cardValidator from "card-validator";
import {CONSTANTS} from "./constants";
import dayjs from "dayjs";

export const checkFormValidity = (event) => {
  let elements = event.target.form.elements;
  let valid = true;
  for (let el in elements) {
    if (elements[el].checkValidity) {
      valid = valid && elements[el].checkValidity();
    }
  }
  return valid;
}

export const formatDateTimeTz = (eventUtc, mask, tz) => {

  const date = new Date(eventUtc);

  let displayDate = null;
  try {
    displayDate = dayjs
      .utc(eventUtc)
      .tz(tz);
  } catch (err) {
    displayDate = dayjs
      .utc(new Date().toISOString())
      .tz(tz);
  }

  return displayDate.format(mask);
}

export const isGuid = (str) => {
  const uuidV4Regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidV4Regex.test(str);
}

export const portalViewUrl = (portalUrl) => {
  let u = portalUrl;
  if (u.match('/#cx/') > -1) {
    u = u.replace('/#/cx/', '')
  }
  if (u.match('#cx/') > -1) {
    u = u.replace('#/cx/', '')
  }
  if (u.match('#cx') > -1) {
    u = u.replace('#/cx', '')
  }
  if (u.endsWith('/')) {
    return u + '#/cx/';
  }

  return u + '/#/cx/';
}

export const sortAttendeesFunction = (a, b) => {
  const getRank = (person) => {
    if (person.primary) return 1;
    if (person.adult && !person.dob) return 2;
    if (person.adult) return 3;
    return 4;
  };

  const rankDiff = getRank(a) - getRank(b);
  if (rankDiff !== 0) return rankDiff;

  if (!a.adult && !b.adult) {
    let dateA = a.dob ? new Date(a.dob) : new Date();
    let dateB = b.dob ? new Date(b.dob) : new Date();
    return dateA.getTime() - dateB.getTime();
  }

  return 0;
};

export const getPreference = (preferences, pref) => {
  if (!preferences || !pref) {
    return false;
  }
  let _pref = preferences[pref];
  if (!_pref) {
    return false;
  }
  return _pref === 'true';
}

export const eventSortTimeFn = (a, b) => {
  const dateA = new Date(a.eventDate);
  const dateB = new Date(b.eventDate);
  const timeA = ((dateA.getHours() * 60) + dateA.getMinutes());
  const timeB = ((dateB.getHours() * 60) + dateB.getMinutes());
  if (timeA - timeB !== 0) {
    return timeA - timeB;
  }
  return a.name.localeCompare(b.name);
}

export const eventsSortFn = (a, b) => {
  const dateA = new Date(a.eventDate);
  const dateB = new Date(b.eventDate);
  if (dateA - dateB !== 0) {
    return dateA - dateB;
  }
  return a.name.localeCompare(b.name);
}

export const displayAgeRange = (ageType) => {
  let d = []

  if (ageType?.minValue) {
    d.push(ageType?.minValue);
  }
  if (ageType?.minValue === 0 && ageType?.minDateType > -1) {
    d.push('Newborn ');
  }
  if (ageType?.minValue && ageType?.minDateType > -1) {
    d.push(ageType?.minDateType == 1 ? 'Months' : 'Years');
  }
  if ((ageType?.minValue === 0 || ageType?.minValue) && ageType?.maxValue) {
    d.push('-')
  }
  if (ageType?.maxValue) {
    d.push(ageType?.maxValue);
  }
  if (ageType?.maxValue && ageType?.maxDateType > -1) {
    d.push(ageType?.maxDateType == 1 ? 'Months' : 'Years');
  } else if (!ageType?.maxValue) {
    d.push('+')
  }

  if (d.length > 0) {
    return d.join(' ');
  }
  return null;
}

export const timeBlockEvent = (event) => {
  return event.timeBlockParentGuid?.length > 0 && event.timeBlockEvents?.length > 0;
}

export const displayEventTime = (event, timeZone, mask) => {
  if (!mask) {
    mask = 'MM/DD/YYYY h:mm a';
  }
  let d = formatDateTimeTz(event.eventDate, mask, timeZone);
  if (event?.eventType?.hideEndTime) {
    return d;
  }
  d += ' - ' + formatDateTimeTz(event.eventEndDate, 'h:mm a', timeZone);
  return d;
}

export const validEvent = (event, caller) => {
  let today = new Date();
  today.setHours(0, 0, 0, 0);
  let validAllDayEvent = event.allDay && new Date(event.eventEndDate).getTime() >= today.getTime();

  if ('Single' === caller) {
    // fall through normal single event logic
  } else {
    if (event.timeBlockParentGuid?.length > 0 && event.timeBlockEvents?.length > 0) {
      const start = dayjs().startOf('day');
      const eventDate = dayjs(event.eventDate);
      if (eventDate.startOf('day').diff(today, 'day') < 0) {
        return false;
      }
      if (!event?.eventType?.restrictedBooking) {
        return true;
      }
    }
  }

  if (event?.eventType?.ongoingBooking) {
    return validAllDayEvent || new Date(event.eventEndDate).getTime() >= new Date().getTime();
  } else if (event?.eventType?.restrictedBooking) {
    let timeUnit = parseInt(event?.eventType?.restrictedBookingType, 10);
    let restrictedBookingValue = event?.eventType?.restrictedBookingValue;
    let diff = new Date(event.eventDate).getTime() - new Date().getTime();
    const now = new Date().getTime();
    const target = new Date(event.eventDate).getTime();
    const difference = target - now;

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference) / (1000 * 60 * 60));
    const minutes = Math.floor((difference) / (1000 * 60));

    if (timeUnit === CONSTANTS.TIME_UNIT.MINUTE) {
      return minutes >= restrictedBookingValue;
    } else if (timeUnit === CONSTANTS.TIME_UNIT.HOUR) {
      return hours >= restrictedBookingValue;
    } else if (timeUnit === CONSTANTS.TIME_UNIT.DAY) {
      return days >= restrictedBookingValue;
    }
  }

  return validAllDayEvent || new Date(event.eventDate).getTime() >= new Date().getTime();
}

export const truncDetail = (desc, words) => {
  if (!desc) {
    return '';
  }

  let _d = desc.split(' ');
  let _e = '';
  for (let i = 0; i < _d.length && i < words; i++) {
    _e += (i === 0 ? '' : ' ') + _d[i];
  }
  if (_d.length > words) {
    _e += '...';
  }
  return _e;
}

export const displayFileSize = (number) => {
  if (number < 1e3) {
    return `${number} bytes`;
  } else if (number >= 1e3 && number < 1e6) {
    return `${(number / 1e3).toFixed(1)} KB`;
  } else {
    return `${(number / 1e6).toFixed(1)} MB`;
  }
}

export const isAuthenticatedCustomer = (sessionUser) => {
  return isSessionCustomer(sessionUser) && sessionUser.guid;
}

export const isSessionPending = (sessionUser) => {
  if (!sessionUser) {
    return true;
  }
  if (sessionUser?.userTypeId === null) {
    return true;
  }
  return false;
};

export const isSessionCustomer = (sessionUser) => {
  if (!sessionUser) {
    return false;
  }
  if (sessionUser?.userTypeId === CONSTANTS.UTYPE_CUSTOMER) {
    return true;
  }
  return false;
};

export const isSessionClient = (sessionUser) => {
  if (!sessionUser) {
    return false;
  }
  if (sessionUser?.userTypeId === CONSTANTS.UTYPE_CLIENT) {
    return true;
  }
  return false;
};

export const isSessionSuperAdmin = (sessionUser) => {
  if (!sessionUser) {
    return false;
  }
  if (sessionUser?.userTypeId === CONSTANTS.UTYPE_ADMIN) {
    return true;
  }
  return false;
};

export const formatDateNoTz = (isoDateString) => {
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",   // full year (2024)
    month: "numeric",  // 1–12 (locale aware)
    day: "numeric"     // 1–31
  }).format(parseLocalDate(isoDateString));
}

function parseLocalDate(isoDateString) {
  const [y, m, d] = isoDateString.split("-").map(Number);
  return new Date(y, m - 1, d); // <-- local date, no timezone shift
}

export const maxMatrixPrice = (event) => {
  let p = 0;
  if (event?.eventMatrix && event?.eventMatrix.entries?.length > 0) {
    for (let j in event?.eventMatrix.entries) {
      if (event?.eventMatrix.entries[j].price > p) {
        p = event?.eventMatrix.entries[j].price;
      }
    }
  }
  return p;
}

export const formatAge = (familyMember) => {
  let dob = familyMember?.dob;
  if (!dob) {
    return '';
  }

  let birthDay = formatDateNoTz(dob);

  let _d = dob.split('-');

  let age = new Date();
  age.setFullYear(_d[0]);
  age.setMonth(_d[1] - 1);
  age.setDate(_d[2]);

  let e6age = Math.floor((new Date().getTime() - age.getTime()) / 3.15576e+10);

  if (e6age > 0) {
    return (e6age) + ' years - ' + birthDay;
  } else {
    return (Math.floor((new Date().getTime() - new Date(age).getTime()) / 1000 / 60 / 60 / 24 / 30)) + ' months - ' + birthDay;
  }
}

export const getDateNoTz = (jsDate) => {
  let d = moment(jsDate);
  if (!d.isValid()) {
    return null;
  }
  return d.toDate();
}

export const formatNumber = (num) => {
  return new Intl.NumberFormat(navigator.language || 'en-US').format(num);
}

export const formatDate = (jsDate) => {
  let d = new Date(jsDate);
  return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
}

function addPadding(value) {
  return value < 10 ? '0' + value : value;
}

export const formatTime = (jsDate) => {
  let d = new Date(jsDate);
  const hours = d.getHours();
  const amPm = hours >= 12 ? 'PM' : 'AM';
  let _hours = (hours > 12 ? hours - 12 : hours);
  if (_hours === 0) {
    _hours = 12;
  }
  return _hours + ":" + addPadding(d.getMinutes()) + ' ' + amPm;
}

export const addDate = (date, numberDays) => {
  let result = new Date(date);
  result.setDate(result.getDate() + numberDays);
  return new Date(result);
}

export const inventoryAvailable = (inventory) => {
  if (!inventory) {
    return 0;
  }
  if (inventory?.publicAvailableQuantity <= 0) {
    return 'Full';
  }
  return inventory?.publicAvailableQuantity || 0;
}

export const displayDuration = (inventory) => {
  if (inventory?.allDay) {
    return 'All Day';
  }
  let duration = inventory?.duration || 0;
  if (duration < 60) {
    return duration + ' minutes';
  }
  let hours = Math.floor(duration / 60);
  let minutes = duration % 60;

  let displayHours = hours > 1 ? ' hours' : ' hour';

  return hours + displayHours + (minutes > 0 ? ' ' + minutes + ' minutes' : '');
}

export const formDate = (jsDate) => {
  let d = moment(jsDate);
  if (!d.isValid()) {
    return null;
  }
  return d.toDate();
}

export const formatDateTime = (jsDate) => {
  return moment(jsDate).format('MM/DD/yyyy hh:mm a');
}

export const formatDisplayMinutes = (duration) => {
  const minutes = Math.floor(duration / 60);
  const remainingSeconds = duration % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const formatDateMask = (jsDate, mask) => {
  return moment(jsDate).format(mask);
}

export const displayDay = (jsDate, format) => {
  return moment(jsDate).format(format);
}
export const formatCurrency = (price) => {
  if (isNaN(price)) {
    return '';
  }

  return '$' + parseFloat(Math.round(100 * price) / 100)
    .toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export const formatDecimal = (price) => {
  if (isNaN(price)) {
    return '';
  }

  return parseFloat(Math.round(100 * price) / 100)
    .toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

export const customerQrCode = (customer) => {
  return 'https://psb.com/qr/cx/' + customer.id + '/' + customer.guid;
}

export const handleDefaultValues = (entity) => {
  if (!entity) {
    return entity;
  }

  if (entity.primaryPhone) {
    entity.primaryPhone = displayPhone(entity.primaryPhone);
  }

  return entity;
};

export const displayPhone = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    let intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return phoneNumberString;
}

export const capitalize = (s) => {
  if (!s) {
    return s;
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const formatExpiration = (expiration) => {
  let cleaned = ('' + expiration).replace(/\D/g, '');

  let expy = cardValidator.expirationDate(expiration);

  // format expiration into MM/YY format
  let match = cleaned.match(/^(0[1-9]|1[0-2])\/?([0-9]{0,4})$/);
  if (match) {
    expiration = [match[1], '/', match[2]].join('');
  }

  expy.expy = expiration;

  return expy;
}


export const formatCreditCard = (cardNumber) => {
  let cleaned = ('' + cardNumber).replace(/\D/g, '');

  let card = cardValidator.number(cardNumber);

  if (card.isPotentiallyValid) {
    cardNumber = cardNumber.replace(/\D/g, '');
    cardNumber = cardNumber.replace(/(\d{4})/g, '$1 ');
    cardNumber = cardNumber.trim();
  }
  card.cardNumber = cardNumber;

  return card;
}

export const customerInitials = (customer) => {
  let s = '';
  s += customer && customer.firstName ? customer.firstName.split('')[0] + '' : '';
  s += customer && customer.lastName ? customer.lastName.split('')[0] + '' : '';
  return s.toUpperCase();
}

export const invert = (hex, bw) => {

  if (!hex) {
    return '#000';
  }

  function padZero(str, len) {
    len = len || 2;
    let zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }


  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    return '#111';
  }
  let r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // https://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
      ? '#000000'
      : '#FFFFFF';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

export const colorize = (str) => {
  if (!str) {
    return '#efefef';
  }
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let j = 0; j < 3; j++) {
    let value = (hash >> (j * 8)) & 0xFF;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
}

export const handleError = (error) => {
  let err = {
    error: true,
    message: error?.response?.data?.message || JSON.stringify(error)
  }
  return err;
}